/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { ReduxUtils } from '@spm/core';
var LIBRARY_ROOT = 'ieg-library';
var GET_FORM_PAGE_DETAILS_TYPES = ReduxUtils.generatePostActionTypes(LIBRARY_ROOT, 'FORMS_PAGE_DETAILS');
var FORM_SEND_PAGE_ANSWERS_TYPES = ReduxUtils.generatePostActionTypes(LIBRARY_ROOT, 'FORMS_PAGE_ANSWERS');
var SET_IEG_HOOK_BINDING_KEY_TYPES = ReduxUtils.generatePostActionTypes(LIBRARY_ROOT, 'FORMS_IEG_HOOK_BINDING_KEY');
var SET_FORM_ID_TYPES = ReduxUtils.generatePostActionTypes(LIBRARY_ROOT, 'FORMS_FORM_ID');
var FORM_UPDATE_PAGE_DETAILS_TYPES = ReduxUtils.generatePostActionTypes(LIBRARY_ROOT, 'FORMS_UPDATE_PAGE_DETAILS');
var FORM_DELETE_SUMMARY_PAGE_RECORD = ReduxUtils.generatePostActionTypes(LIBRARY_ROOT, 'FORM_DELETE_SUMMARY_PAGE_RECORD');
var FORM_DETAILS_TYPES = ReduxUtils.generatePostActionTypes(LIBRARY_ROOT, 'FORM_DETAILS');
var FORM_SUBMIT_ENABLED_TYPES = ReduxUtils.generatePostActionTypes(LIBRARY_ROOT, 'SUBMIT_ENABLED');
var FORM_GO_TO_PAGE = ReduxUtils.generatePostActionTypes(LIBRARY_ROOT, 'FORM_GO_TO_FIRST_PAGE');
export { SET_FORM_ID_TYPES, SET_IEG_HOOK_BINDING_KEY_TYPES, GET_FORM_PAGE_DETAILS_TYPES, FORM_SEND_PAGE_ANSWERS_TYPES, FORM_UPDATE_PAGE_DETAILS_TYPES, FORM_DELETE_SUMMARY_PAGE_RECORD, FORM_DETAILS_TYPES, FORM_SUBMIT_ENABLED_TYPES, FORM_GO_TO_PAGE };